import {
  IAttendanceSortList,
  IAttendanceStatus,
} from '@/interfaces/attendance.model';
import { IFilterSideBarForm } from '@/interfaces/common.model';
import { IEmployeeList } from '@/interfaces/employee.model';
import { IWfhSortList } from '@/pages/HRM/WFH/TeamWfh';
import { setUpdateFilterStates } from '@/redux/features/UserSlice';
import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap';
import Button from '../ui/Button';
import {
  ILeavePageStates,
  IRemainingLeaveItem,
} from '@/pages/HRM/Leave/MyLeave';
import { ITeamLeaveSort } from '@/interfaces/leave.model';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
export interface IAssetSortList {
  assetCategory?: { id: string; name: string }[];
  assetStatus?: { value: number; label: string }[];
}
export interface IFilterSidebarProps<T> {
  employeeList?: IEmployeeList;
  isOpen: boolean;
  toggle: () => void;
  sortList: T;
  attendanceList?: IAttendanceStatus[] | null;

  attendanceSortList?: IAttendanceSortList;
  sortHandler?: (
    data: Partial<IFilterSideBarForm> | null,
    type?: null | string,
  ) => void;
  wfhStatus?: IWfhSortList;
  leaveList?: IRemainingLeaveItem[];
  handleFilterForLeave?: React.Dispatch<React.SetStateAction<ILeavePageStates>>;
  TeamLeaveSort?: ITeamLeaveSort;
  userStatus?: boolean;
  assetSortList?: IAssetSortList;
}
const FilterSidebar = <T,>({
  isOpen,
  toggle,
  sortList,
  attendanceList,
  attendanceSortList,
  sortHandler,
  wfhStatus,
  employeeList,
  leaveList,
  TeamLeaveSort,
  userStatus,
  assetSortList,
}: IFilterSidebarProps<T>) => {
  const { handleSubmit, register, reset, setValue, watch } =
    useForm<IFilterSideBarForm>({ shouldUnregister: false });
  const dispatch = useDispatch();
  const filterDetails = useSelector(
    (state: RootState) => state.user?.filtersStates,
  );
  // const [disabled, setDisabled] = useState<boolean>(true);
  const department = attendanceSortList
    ? attendanceSortList?.department
    : employeeList?.department;
  const designation = attendanceSortList
    ? attendanceSortList?.designation
    : employeeList?.designation;
  const assetCategory = assetSortList?.assetCategory;
  const assetStatus = assetSortList?.assetStatus;

  useEffect(() => {
    if (!isOpen) return;
    const { requestType, stockStatus, department, designation, empStatus } =
      filterDetails || {};
    setValue('requestType', requestType || '');
    setValue('stockStatus', stockStatus || '');
    setValue('department', department || '');
    setValue('designation', designation || '');
    setValue('attendanceStatus', filterDetails?.attendanceStatus || '');
    setValue('leaveType', filterDetails?.leaveType || '');
    setValue('leaveStatus', filterDetails?.leaveStatus || '');
    if (department) {
      // setDisabled(false);
    } else {
      // setDisabled(true);
    }

    if (empStatus == '') {
      setValue('status', 'current');
    } else {
      setValue('status', empStatus || '');
    }
    setValue('assetCategoryId', filterDetails?.assetCategoryId || '');
    setValue('assetStatus', filterDetails?.assetStatus || '');
  }, [isOpen, filterDetails, setValue]);
  const onSubmit: SubmitHandler<IFilterSideBarForm> = (data) => {
    if (sortHandler) {
      sortHandler(data);
    }
    toggle();
  };
  if (!sortList) return;
  // const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
  //   // const department = watch('department');
  //   if (e.target.value !== '') {
  //     const data = {
  //       department: e.target.value,
  //     };
  //     if (sortHandler) {
  //       sortHandler(data);
  //     }
  //     reset({
  //       designation: '',
  //     });
  //     setDisabled(false);
  //   } else {
  //     setDisabled(true);
  //   }
  // };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    // const department = watch('department');
    if (e.target.value !== '') {
      const data = {
        department: e.target.value,
      };
      if (sortHandler) {
        sortHandler(data, 'department');
      }
      reset((prev) => ({
        ...prev,
        designation: '',
      }));
      // setDisabled(false);
      setValue('department', e.target.value);
    } else {
      // setDisabled(true);
      setValue('designation', '');
    }
  };

  const handleClearFilter = () => {
    if (sortHandler) {
      sortHandler(null);
    }

    reset();
    dispatch(
      setUpdateFilterStates({
        customerId: '',
        customerCompanyId: '',
      }),
    );
    toggle();
    // setDisabled(true);
  };

  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction="end"
      className="filters"
    >
      <OffcanvasHeader toggle={toggle} className="p-4 border-bottom">
        <h3>Filters</h3>
      </OffcanvasHeader>
      <OffcanvasBody className="p-4 ">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="h-100 d-flex flex-column justify-content-between"
        >
          <div className="row">
            {attendanceList && (
              <div className="d-flex align-items-center gap-3">
                <select
                  className="form-select min-w-20 pe-5"
                  aria-label="Default select "
                  {...register('attendanceStatus')}
                >
                  <option value={''} className="d-none">
                    Select Attendance Status
                  </option>
                  {attendanceList &&
                    attendanceList.length > 0 &&
                    attendanceList.map((item, i) => {
                      return (
                        <option value={item?.value} key={i}>
                          {item?.label}
                        </option>
                      );
                    })}
                </select>
              </div>
            )}
            {(attendanceSortList?.department || employeeList?.department) && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    Depatment
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    {...register('department')}
                    onChange={(e) => handleChange(e)}
                  >
                    <option value={''}>Select Department</option>
                    {department?.map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                  {/* {errors.leaveType && <div className="form-text text-danger">{errors.leaveType.message}</div>} */}
                </div>
              </div>
            )}
            {designation && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    Designation
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    {...register('designation')}
                    disabled={!watch('department')}
                  >
                    <option value={''}>Select Designation</option>
                    {designation?.map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                  {/* {errors.leaveType && <div className="form-text text-danger">{errors.leaveType.message}</div>} */}
                </div>
              </div>
            )}
            {attendanceSortList?.attendanceStatus && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    Attendance Status
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    {...register('attendanceStatus')}
                  >
                    <option value={''} className="d-none">
                      Select Attendance Status
                    </option>
                    {attendanceSortList?.attendanceStatus?.map(
                      (item, index) => {
                        return (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        );
                      },
                    )}
                  </select>
                  {/* {errors.leaveType && <div className="form-text text-danger">{errors.leaveType.message}</div>} */}
                </div>
              </div>
            )}
            {attendanceSortList?.attendanceType && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    Attendance Type
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    {...register('attendanceType')}
                  >
                    <option value={''} className="d-none">
                      Select Attendance Type
                    </option>
                    {attendanceSortList?.attendanceType?.map((item, index) => {
                      return (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                  {/* {errors.leaveType && <div className="form-text text-danger">{errors.leaveType.message}</div>} */}
                </div>
              </div>
            )}
            {wfhStatus?.wfhStatus && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    WFH Status
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    {...register('oDStatus')}
                  >
                    {wfhStatus?.wfhStatus?.map((item, index) => {
                      return (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            )}
            {leaveList && (
              <div className="col-12">
                <div className="d-flex align-items-center gap-3">
                  <select
                    className="form-select min-w-20 pe-5"
                    aria-label="Default select "
                    {...register('leaveType')}
                    // onChange={(e) =>
                    //   handleFilterForLeave((pre) => ({
                    //     ...pre,
                    //     leaveType: e.target.value,
                    //   }))
                    // }
                  >
                    <option value={''} className="d-none">
                      Select Leave Type
                    </option>
                    {leaveList &&
                      leaveList.length > 0 &&
                      leaveList.map((item, i) => {
                        return (
                          <option value={item?.leaveType} key={i}>
                            {item?.leaveType}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>
            )}
            {TeamLeaveSort?.leaveType && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    Leave Type
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    {...register('leaveType')}
                  >
                    <option value={''}>Select leave type</option>
                    {TeamLeaveSort?.leaveType?.map((item, index) => {
                      return (
                        <option key={index} value={item?.type}>
                          {item?.type}
                        </option>
                      );
                    })}
                  </select>
                  {/* {errors.leaveType && <div className="form-text text-danger">{errors.leaveType.message}</div>} */}
                </div>
              </div>
            )}
            {TeamLeaveSort?.leaveStatus && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    Leave Status
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    {...register('leaveStatus')}
                  >
                    {TeamLeaveSort?.leaveStatus?.map((item, index) => {
                      return (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                  {/* {errors.leaveType && <div className="form-text text-danger">{errors.leaveType.message}</div>} */}
                </div>
              </div>
            )}
            {userStatus && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    User Status
                  </label>
                  <select
                    className="form-select min-w-20 pe-5"
                    id="status"
                    {...register('status')}
                  >
                    <option value={''} hidden>
                      Select Status
                    </option>
                    <option value="current">Current</option>
                    <option value="exEmployee">Ex-Employee</option>
                    <option value="all">All</option>
                  </select>
                </div>
              </div>
            )}
            {assetCategory && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    Asset Category
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    {...register('assetCategoryId')}
                  >
                    <option value={''} disabled>
                      Select Category
                    </option>
                    {assetCategory?.map((item, index) => {
                      return (
                        <option key={index} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            )}
            {assetStatus && (
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label">
                    Asset Status
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    {...register('assetStatus')}
                  >
                    <option value={''} disabled>
                      Select Status
                    </option>
                    {assetStatus?.map((item, index) => {
                      return (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            )}
          </div>
          {/* Buttons */}
          <div className="d-flex align-items-center justify-content-end gap-3">
            <Button className="btn btn-primary " type="submit">
              Apply Filters
            </Button>
            <Button
              type="button"
              className="btn btn-danger"
              onClick={handleClearFilter}
            >
              Clear All
            </Button>
          </div>
        </form>
      </OffcanvasBody>
    </Offcanvas>
  );
};
export default FilterSidebar;
